import { Injectable } from '@angular/core';
import { CompleteOrderBackendService } from '@complete-order/services/complete-order-backend.service';
import {
  CardPaymentRedirectRequest,
  CardPaymentRedirectResponse,
} from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromCardPaymentRedirect from '../actions/card.payment.redirect.action';

@Injectable()
export class CardPaymentRedirectEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly completeOrderBackendService: CompleteOrderBackendService,
    public readonly buildConfigService: BuildConfigService
  ) {}

  loadCardPaymentRedirect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromCardPaymentRedirect.loadCardPaymentRedirect),
      switchMap(
        ({
          payload,
        }: {
          payload: {
            request: CardPaymentRedirectRequest;
            addressChanged: boolean;
          };
        }) => {
          return this.completeOrderBackendService
            .postCardPaymentRedirect(
              `${this.buildConfigService.config.common}/v2/card/payment-redirect`,
              payload.request
            )
            .pipe(
              map((response: CardPaymentRedirectResponse) =>
                fromCardPaymentRedirect.loadCardPaymentRedirectSuccess({
                  payload: {
                    request: payload.request,
                    response: response,
                    addressChanged: payload.addressChanged,
                  },
                })
              ),
              catchError(() =>
                of(
                  fromCardPaymentRedirect.loadCardPaymentRedirectFail({
                    payload: 'error',
                  })
                )
              )
            );
        }
      )
    )
  );
}
